import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
// @refresh reset

export default function BouncingLine({ isFixed }) {
	const wordRef = useRef()
	const lineRef = useRef()
	useEffect(() => {
		const timeUnit = 0.8

		const tl = gsap
			.timeline({
				// paused: true,
				repeat: -1,
				delay: 2.5 * timeUnit,
				repeatDelay: 2.5 * timeUnit,
			})
			.to(lineRef.current, {
				translateY: 0,
				duration: 1.5 * timeUnit,
				ease: 'power2.in',
			})
			.to(lineRef.current, { height: '0%', duration: timeUnit, ease: 'power2.out' })
			.to(
				wordRef.current,
				{ opacity: 1, duration: 0.05 * timeUnit, ease: 'power2.out' },
				'<'
			)
			.to(
				wordRef.current,
				{ letterSpacing: '28px', duration: 1.8 * timeUnit, ease: 'power2.out' },
				'<'
			)
			.to(
				wordRef.current,
				{ opacity: 0, duration: 0.9 * timeUnit, ease: 'power1.in' },
				'<50%'
			)

		return () => tl.kill()
	})

	return (
		<div
			className={
				(isFixed ? 'fixed ' : 'absolute ') +
				'pointer-events-none top-0 left-1/2 z-10 -ml-30 flex h-screen w-60 flex-col pt-6 pb-72 lg:pb-0 lg:pt-9'
			}
		>
			<div
				className="mt-px w-full text-center text-xs font-semibold leading-none text-white"
				style={{ opacity: 0, letterSpacing: '-10px' }}
				ref={wordRef}
			>
				<span className="inline pl-3.5 lg:hidden">SWIPE</span>
				<span className="hidden pl-3.5 lg:inline">SCROLL</span>
			</div>
			<div className="mx-auto w-1 flex-grow overflow-hidden pt-6">
				<svg
					style={{ transform: 'translateY(100%)' }}
					className="h-full w-px"
					ref={lineRef}
				>
					<defs>
						<linearGradient
							id="line-gradient"
							x1="0%"
							y1="0%"
							x2="0%"
							y2="100%"
						>
							<stop offset="0%" stopColor="rgba(255, 255, 255, 100)" />
							<stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
						</linearGradient>
					</defs>
					<rect
						x="0"
						y="0"
						width="1"
						height="100%"
						fill="url(#line-gradient)"
					/>
				</svg>
			</div>
		</div>
	)
}
